var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8477 5.25C8.06336 5.25 4.97572 8.23843 4.81622 11.9836C4.80532 12.2405 5.00145 12.2548 5.00145 12.2548H6.19563C6.42775 12.2548 6.46843 12.1223 6.47391 12.0036C6.6054 9.16374 8.97184 6.90724 11.8477 6.90724C13.3828 6.90724 14.7674 7.55073 15.7477 8.5823L14.9097 9.39267C14.764 9.56819 14.7666 9.78129 14.9819 9.84148L18.503 10.5503C18.8043 10.6256 19.1625 10.3972 19.0395 9.92831L18.2078 6.68595C18.1866 6.5632 17.9809 6.37215 17.7888 6.50919L16.8755 7.36452C15.5981 6.05985 13.8175 5.25 11.8477 5.25ZM17.6841 12.4952C17.452 12.4952 17.4113 12.6277 17.4058 12.7463C17.2744 15.5862 14.9079 17.8427 12.0321 17.8427C10.497 17.8427 9.11238 17.1997 8.13205 16.1681L8.97003 15.3573C9.11577 15.1818 9.11312 14.9687 8.89789 14.9085L5.3768 14.1997C5.07545 14.1244 4.71728 14.3528 4.84027 14.8217L5.67201 18.0641C5.69313 18.1868 5.8989 18.3779 6.09099 18.2408L7.00422 17.3855C8.2817 18.6901 10.0623 19.5 12.0321 19.5C15.8164 19.5 18.904 16.5116 19.0635 12.7664C19.0744 12.5095 18.8783 12.4952 18.8783 12.4952L17.6841 12.4952Z",
    fill: "#FEB91E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOil);
export default __webpack_public_path__ + "static/media/ChangeOil.7d8afc19e963ad741dbbc114ce4c28ac.svg";
export { ForwardRef as ReactComponent };